import { useMemo } from "react";
import jwtDecode from "jwt-decode";

import { IIdToken, Optional } from "config";
import { useAppSelector } from "store";

const useIdToken = (): Optional<IIdToken> => {
  const idToken = useAppSelector((state) => state.AuthReducer.idToken);

  return useMemo(
    () => (idToken ? jwtDecode<IIdToken>(idToken) : undefined),
    [idToken]
  );
};

export default useIdToken;
